(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

	}

	document.addEventListener('shopify:section:load', footer);
	footer();
})();

/* userway.org initialisation! */
const _userway_config = {
	/* uncomment the following line to override default position*/
	position: '6',
	/* uncomment the following line to override default size (values: small, large)*/
	size: 'small',
	/* uncomment the following line to override default language (e.g., fr, de, es, he, nl, etc.)*/
	/* language: 'en-US', */
	/* uncomment the following line to override color set via widget (e.g., #053f67)*/
	color: '#7582c1',
	/* uncomment the following line to override type set via widget(1=person, 2=chair, 3=eye)*/
	/* type: '2', */
	/* uncomment the following line to override support on mobile devices*/
	/* mobile: true, */
	account: 'x6Ip2IAsv3'
};